import Button from "@/UI/Button";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FaDownload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import "./card.css";
import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { exportToCSV } from "@/utils/exportUtils";

const LeadsCreateMany = ({
  urlPath,
  loadAllThunk,
  query,
  demoData,
  title,
  invalidTags,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState();
  const navigate = useNavigate();
  const fileReader = new FileReader();

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    
    setLoader(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const resp = await axios.post(`${import.meta.env.VITE_APP_API}/${urlPath}/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (resp.status === 201 || resp.status === 200) {
        const { stats, errors } = resp.data;

        if (stats.success > 0) {
          toast.success(`${stats.success} ${t("common.uploadedSuccess")}`);
        }

        if (errors && errors.length > 0) {
          toast.error(
            <div className="max-h-60 overflow-y-auto text-left">
              <p className="font-bold mb-1 underline">Skipped Records:</p>
              {errors.map((errorObj, index) => (
                <div key={index} className="text-[11px] border-b border-gray-100 py-1 last:border-0 drop-shadow-sm">
                  {errorObj.name}: {errorObj.error}
                </div>
              ))}
            </div>,
            { duration: 6000 }
          );
        }

        if (loadAllThunk) {
          dispatch(loadAllThunk(query));
        }
        if (invalidTags) {
          dispatch(apiSlice.util.invalidateTags(invalidTags));
        }
        setFile(null);
      }
      setLoader(false);
    } catch (err) {
      setLoader(false);
      const errorMessage = err?.response?.data?.error || t("errors.somethingWentWrong");
      toast.error(errorMessage);
    }
  };

  const downloadDemoCSV = () => {
    exportToCSV(demoData, title || "demo_leads");
  };

  return (
    <div className="text-center mt-2  ">
      {!file && (
        <div className="flex flex-col items-center gap-2 mb-2" style={{ color: "red" }}>
          {t("common.pleaseSelectCSVFile")}
          <Button
            onClick={downloadDemoCSV}
            className="px-5 py-1 max-w-[150px] bg-teal-500 text-white border rounded-md">
            <div className="flex items-center justify-center gap-2 text-sm">
              <FaDownload /> <span>{t("common.demoCSV")}</span>
            </div>
          </Button>
        </div>
      )}
      <form className="form-group">
        <div className="flex items-center gap-2 mb-4">
          <input
            required={true}
            type="file"
            id="csvFileInput"
            accept=".csv"
            onChange={handleOnChange}
            className="hidden"
          />
          <label
            htmlFor="csvFileInput"
            className="cursor-pointer inline-flex items-center px-4 py-2 text-sm font-semibold rounded-full border-0 bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors">
            {t("common.chooseFile")}
          </label>
          <span className="text-sm text-slate-500">
            {file ? t("common.fileSelected") + ": " + file.name : t("common.noFileChosen")}
          </span>
        </div>
        <Button
          loading={loader}
          className="rounded-lg bg-blue-500 text-white font-bold px-4 disabled:opacity-50"
          disabled={!file}
          type="submit"
          onClick={handleOnSubmit}>
          {t("common.importFromCSV")}
        </Button>
      </form>
    </div>
  );
};

export default LeadsCreateMany;
